var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "block",
    { staticStyle: { "padding-bottom": "30px" } },
    [
      _c("template", { slot: "header" }, [_vm._v("\n    Alerta Manual\n  ")]),
      _vm._v(" "),
      _c("div", { staticClass: "msg" }, [
        _c("h4", { staticClass: "is-uppercase" }, [
          _vm._v("Alerta manual registrada exitosamente")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "is-marginless" }, [
          _vm._v("Ahora puedes agregar una atención para el estudiante.")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary",
            on: {
              click: function($event) {
                return _vm.navigateTo("app.profile.add_attention")
              }
            }
          },
          [_vm._v("\n      Sí, agendar atención\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            on: {
              click: function($event) {
                return _vm.navigateTo("app.profile.alerts")
              }
            }
          },
          [_vm._v("No, volver")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }